import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { GetVodafonePKRequest, GetVodafonePKResponse } from '../models/model'

export class GetPKListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'VodafoneReports/GetVodafonePKList',
      requesterInfo,
    })
  }

  public async getPKList(request: GetVodafonePKRequest): Promise<GetVodafonePKResponse[]> {
    return await this.postAsync<GetVodafonePKResponse[]>(request)
  }
}